import styled from '@emotion/styled';

export const StyledLoading = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  object {
    max-width: 100%;
  }
`;
